import * as Yup from 'yup'

const yupZone = Yup.object().shape({
  formInput: Yup.object().shape({
    zoneName: Yup.string().required('Plese Enter Zone Name'),
  }),
})

export default yupZone
